import axios from "axios";

export default function ScheduleDoneService(scheduleId, jobs) {
  return axios({
    method: 'put',
    url: process.env.REACT_APP_API_HOST + "/schedule/" + scheduleId + "/done",
    data: {
      reScheduleItems: jobs
    },
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
